import React, { useEffect } from 'react';
import DetailsComponent from '../../Components/DetailsComponent/DetailsComponent';
import { GoogleTagManager } from '../../../../../helpers';

const LastStep = () => {
  useEffect(() => {
    GoogleTagManager.pushToDataLayer({
      event: 'pagina-virtual',
      page: '/marketplace/categorias/formulario-recargas/paso-3',
      pagename: 'Formulario Recargas Paso 3',
    });
  }, []);
  return (
    <DetailsComponent
      title="Detalle del inconveniente"
      subtitle="Te pedimos que nos des el mayor detalle posible para poder resolver el problema."
      optional
    />
  );
};

export default LastStep;
